<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="类型筛选">
          <el-button-group>
            <el-button @click="changeTypeFunc('')">不限</el-button>
            <el-button :type="formInline.type == item.key_name ? 'primary' : ''" plain v-for="(item, index) in typeData" :key="index" @click="changeTypeFunc(item.key_name)">{{item.name}}</el-button>
          </el-button-group>
        </el-form-item>
        <br>
        <el-form-item label="激活码">
          <el-input v-model="formInline.code" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="formInline.role_id" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(item,index) in roleData" :key="index" :label="item.name" :value="item.role_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option label="不限" value=""></el-option>
            <el-option label="未激活" value="1"></el-option>
            <el-option label="已激活" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="添加时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>

        <el-form-item label="激活时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.use_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="openPopup('add')">添加</el-button>
      <el-button size="small" type="primary" @click="openPopup('batch')" icon="el-icon-check">批量操作</el-button>
    </div>


    <!--内容-->
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" ref="dragTable" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange" :row-key="getRowKey"  @selection-change="tableCurrentChange">
          <el-table-column type="selection" :reserve-selection="true" align="center" width="45"></el-table-column>
          <el-table-column prop="code_id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="type.name" label="类型" align="center">
            <template slot-scope="scope" v-if="typeData[scope.row.type]">
              {{ typeData[scope.row.type].name }} ({{ scope.row.type }})
            </template>
          </el-table-column>
          <el-table-column prop="code" label="激活码"></el-table-column>          
          <el-table-column prop="role_str" label="角色" align="center"></el-table-column>          
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span class="gray9" v-if="scope.row.status == 1">未激活</span>
              <span class="green" v-else-if="scope.row.status == 2">已激活</span>
            </template>
          </el-table-column>
          <el-table-column prop="use_time" label="激活" sortable="custom">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 2">
                <p>{{ scope.row.user.nickName }} ({{ scope.row.user_id }})</p>
                <p>{{ scope.row.use_time }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140" sortable="custom"></el-table-column>
          <el-table-column prop="operate" label="操作" width="120">
                <template slot-scope="scope">
                    <!-- <el-button @click="editFun(scope.row)" type="text" size="small">编辑</el-button> -->
                    <el-button @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <Add v-if="show_popup['add']" :open_add="show_popup['add']" :typeData="typeData" :roleData="roleData" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--编辑-->
    <!-- <Edit v-if="open_edit" :open_edit="open_edit" :typeData="typeData" :form="form" @closeDialog="closeDialogFunc($event, 'edit')"></Edit> -->

    <!--批量-->
    <Batch v-if="show_popup['batch']" :is_open="show_popup['batch']" :typeData="typeData" :ids="ids" @closeDialog="closeDialogFunc($event, 'batch')"></Batch>

  </div>
</template>

<script>
  import CodeApi from '@/api/study/code.js';
  import Edit from './part/Edit.vue';
  import Add from './part/Add.vue';
  import Batch from './part/Batch';
  import qs from 'qs';
  export default {
    components: {
        /*编辑组件*/
        Edit,
        Add,
        Batch,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          type: '',
          code: '',
          status: '',
          create_time: '',
          role_id: '',
        },
        typeData: {},
        roleData: {},
        /*选中的对象*/
        selectModel:{},
        /*弹窗*/
        show_popup: {
          add: false,
          batch: false,
        },
         /*批量操作*/
        multipleSelection: [],
        ids: [],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      // 默认
      let type = this.$db.getRouteField(this, 'type');
      if (type) this.formInline.type = type;

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
      getRowKey (row) {
        return row.code_id;
      },
      /*监听复选按钮选中事件*/
      tableCurrentChange(val) {
        this.multipleSelection = val;
        this.ids = [];
        val.forEach(e => {
          this.ids.push(e.code_id);
        });
      },
      /*跳转详情*/
      onDetail(row) {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let params = {question_id: row.question_id};
        baseUrl = this.$filter.isDebug() ? '' : '/shop';
        window.open(baseUrl + '/#/study/questionlibrary/index?' + qs.stringify(params));
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        CodeApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.totalDataNumber = data.list.total;
          self.typeData = data.type;
          self.roleData = data.role;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
        this.ids = [];
        this.$refs.dragTable.clearSelection();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*删除*/
        deleteFun(row) {
          let self = this;
          self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() =>
          {
              self.loading = true;
              CodeApi.del({
                  code_id: row.code_id
              }, true)
                  .then(data =>
                  {
                      self.loading = false;
                      self.$message({
                          message: data.msg,
                          type: 'success'
                      });
                      self.getTableList();

                  })
                  .catch(error =>
                  {
                      self.loading = false;
                  });

          }).catch(() =>
          {

          });
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.show_popup[name] = true;
        if (item) this.selectModel = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },

      /*导出*/
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/study.code/export?' + qs.stringify(this.formInline);
      },

      /*选择类型*/
      changeTypeFunc(e){
        this.formInline.type = e;
        this.$db.setRoute(this, {'type': e});
        this.getTableList();
        this.ids = [];
        this.$refs.dragTable.clearSelection();
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/code/code/Index.vue